import { ContractFunnelDto } from "api/pricing";
import { ContractFunnel } from "features/subscription-process/pricing-process/types/interfaces";
import { createObjectHash } from "helpers/createObjHash";

export const createContractFunnelHash = (contractFunnel: Omit<ContractFunnelDto, 'hash'>): string => {
  const hashData = {
    id: contractFunnel.id,
    contractIdentifier: contractFunnel.contractIdentifier,
    supportId: contractFunnel.supportId,
    variables: contractFunnel.variables.map(v => ({
      variableValueId: v.variableValueId,
      variableRefId: v.variableRefId,
      value: v.value,
      code: v.code
    })).sort((a, b) => a.code.localeCompare(b.code)),
    fees: contractFunnel.fees?.map(f => ({
      code: f.code,
      value: f.value
    })).sort((a, b) => a.code.localeCompare(b.code)) || [],
    guarantees: contractFunnel.guarantees.map(g => ({
      id: g.id,
      deductible: g.deductible ? {
        id: g.deductible.id,
        value: g.deductible.value
      } : null
    })).sort((a, b) => a.id.localeCompare(b.id))
  };

  return createObjectHash(hashData);
};
